import { render, staticRenderFns } from "./NetWorthType.vue?vue&type=template&id=c2739a2a&"
import script from "./NetWorthType.vue?vue&type=script&lang=js&"
export * from "./NetWorthType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports